module.exports = __webpack_public_path__ + "img/closeBtn.599db650.svg";